var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49933 0C7.87706 0 7.37433 0.502734 7.37433 1.125V1.8C4.80792 2.32031 2.87433 4.59141 2.87433 7.3125V7.97344C2.87433 9.62578 2.26612 11.2219 1.16925 12.4594L0.909093 12.7512C0.61378 13.0816 0.543468 13.5563 0.722765 13.9605C0.902061 14.3648 1.30636 14.625 1.74933 14.625H15.2493C15.6923 14.625 16.0931 14.3648 16.2759 13.9605C16.4587 13.5563 16.3849 13.0816 16.0896 12.7512L15.8294 12.4594C14.7325 11.2219 14.1243 9.6293 14.1243 7.97344V7.3125C14.1243 4.59141 12.1907 2.32031 9.62433 1.8V1.125C9.62433 0.502734 9.12159 0 8.49933 0ZM10.0919 17.3426C10.5138 16.9207 10.7493 16.3477 10.7493 15.75H8.49933H6.24933C6.24933 16.3477 6.48487 16.9207 6.90675 17.3426C7.32862 17.7645 7.90167 18 8.49933 18C9.09698 18 9.67003 17.7645 10.0919 17.3426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationMob);
export default __webpack_public_path__ + "static/media/notification_mob.7d5975cc2eb4882750ba5b0a3f8e0490.svg";
export { ForwardRef as ReactComponent };